module.exports = __webpack_public_path__ + "img/measurement_info_left_chest_back.868f2a35.jpg";